import { Column } from '@tempmee/react';
import { RichTextViewer } from '~/commonComponents';

interface IJobDescriptionPreviewProps {
  description: string;
}

export const JobDescriptionPreview = ({ description }: IJobDescriptionPreviewProps) => {
  return (
    <Column gap={4}>
      <RichTextViewer content={description} />
    </Column>
  );
};
